export const journey1 = {
    id: 'journey-1',
    schemaVersion: 2,
    covers: "A single hook over one continuous run of treatment footage, closing on the clinic's name. One idea, said once — no list, no steps.",
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 177,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 8],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 0.333,
                            transition: 'cut',
                        },
                        {
                            atSec: 0.4,
                            transition: 'cut',
                        },
                        {
                            atSec: 1.533,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.467,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.767,
                            transition: 'fade',
                        },
                        {
                            atSec: 4.167,
                            transition: 'cut',
                        },
                        {
                            atSec: 4.6,
                            transition: 'cut',
                        },
                        {
                            atSec: 5.533,
                            transition: 'cut',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'text',
                id: 'scene-0',
                text: {
                    source: 'query',
                    query: {
                        kind: 'content',
                        field: 'hook',
                    },
                    required: true,
                },
                style: 'display',
                styleOverride: {
                    colorRole: 'onPrimary',
                    textTransform: 'none',
                    fontSize: 50,
                    lineHeight: 1.21,
                    fontWeight: 500,
                },
                duration: {
                    kind: 'fixed',
                    frames: 70,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                placement: {
                    anchor: 'center',
                    x: 0.497,
                    y: 0.3652,
                    width: 0.52,
                },
                animation: {
                    entrance: 'none',
                },
            },
            {
                kind: 'group',
                id: 'scene-1',
                duration: {
                    kind: 'fixed',
                    frames: 102,
                },
                start: {
                    at: 'frame',
                    value: 75,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.3537,
                    width: 0.8,
                },
                root: {
                    kind: 'stack',
                    direction: 'h',
                    width: 'hug',
                    align: 'center',
                    gap: 18,
                    children: [
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '✨',
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 65.5,
                                fontWeight: 500,
                            },
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'slot',
                                slot: {
                                    source: 'query',
                                    query: {
                                        kind: 'content',
                                        field: 'payoff',
                                    },
                                    required: true,
                                },
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 50,
                                fontWeight: 500,
                                fontStyle: 'italic',
                            },
                            entrance: 'fade-in',
                            align: 'center',
                        },
                        {
                            kind: 'text',
                            content: {
                                source: 'literal',
                                text: '✨',
                            },
                            style: 'display',
                            styleOverride: {
                                colorRole: 'onPrimary',
                                textTransform: 'none',
                                fontSize: 65.5,
                                fontWeight: 500,
                            },
                            align: 'center',
                        },
                    ],
                    justify: 'center',
                },
            },
            {
                kind: 'text',
                id: 'brand-card-0',
                text: {
                    source: 'query',
                    query: {
                        kind: 'brand',
                        field: 'businessName',
                    },
                    required: false,
                },
                style: 'display',
                styleOverride: {
                    colorRole: 'onPrimary',
                    fontSize: 50,
                    fontWeight: 500,
                    textTransform: 'none',
                },
                duration: {
                    kind: 'fixed',
                    frames: 177,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                placement: {
                    anchor: 'center',
                    x: 0.501,
                    y: 0.7892,
                    width: 0.6,
                },
                animation: {
                    entrance: 'fade-in',
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        hook: {
            type: 'text',
            maxChars: 40,
            description: 'Opens the confession and LEAVES IT UNFINISHED — a first-person admission that sets up the wrong assumption, breaking off mid-sentence so `payoff` can land it. Written in FIRST PERSON, spoken not advertised, and this field overrides the third-person voice rule. Source shape: "ohhh, I wasn\'t sad, I just needed a...". Wraps to two lines.',
        },
        payoff: {
            type: 'text',
            maxChars: 24,
            description: 'Completes the exact sentence `hook` breaks off, and IS the punchline — the treatment, named plainly and a little flatly, so the reveal does the work. Read the two fields aloud together: they must be one sentence. Source shape: "a facial appointment". A separate claim here kills the joke.',
        },
    },
    structure: 'A first-person confession that sets up a wrong assumption and then corrects it, with the treatment as the punchline. `hook` opens the confession and TRAILS OFF unfinished; `payoff` completes that exact sentence and is the joke landing. Read aloud, the two are one line. The source is: "ohhh, I wasn\'t sad, I just needed a... a facial appointment" — light, self-deprecating, spoken not advertised.',
};
//# sourceMappingURL=journey-1.js.map